const testimonials = [
  {
    name: "Ricardo M.",
    location: "Coral Gables, FL",
    rating: 5,
    text: "I run a private equity firm on Ponce de Leon Boulevard and fly to Sao Paulo at least quarterly. Five days before a deal closing, I discovered my passport had expired two months earlier. Fast Passport Center processed my renewal in three business days. I made my flight, closed the deal, and have since set a calendar reminder six months before every expiration. The team understood the urgency of a business trip that could not be rescheduled.",
    service: "Passport Renewal",
  },
  {
    name: "Jennifer K.",
    location: "Coral Gables, FL — University of Miami Student",
    rating: 5,
    text: "I was accepted into a semester-abroad program in Madrid and had three weeks before departure. When I pulled my passport out of my desk drawer, it had expired eight months ago. I panicked. Fast Passport Center walked me through exactly what I needed, I shipped everything from the UPS Store on Miracle Mile, and my new passport arrived in five business days. I made my flight to Madrid and did not miss a single day of the program.",
    service: "New Passport",
  },
  {
    name: "The Martinez Family",
    location: "Coral Gables, FL",
    rating: 5,
    text: "We booked a seven-day Caribbean cruise from the Port of Miami for our family of four. Eight days before sailing, I checked our passports and discovered our daughter's had expired four months prior. The cruise line would not budge on the requirement. Fast Passport Center processed her child passport in three days. We made the cruise — and now I check every family member's passport the day we book any international trip, not the week before.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CoralGablesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Coral Gables Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Coral Gables, Miami, and Miami-Dade County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}